var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavOfferings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.006 1a8.97 8.97 0 0 1 4.078.982c4.428 2.257 6.19 7.675 3.933 12.102a8.997 8.997 0 0 1-12.102 3.934A8.998 8.998 0 0 1 1.983 5.916 8.998 8.998 0 0 1 10.006 1Zm0 1.381c-.302 0-.6.018-.898.053l-1.912 2.07-2.798.331a7.662 7.662 0 0 0-1.871 3.672l1.379 2.46-.551 2.764a7.587 7.587 0 0 0 2.917 2.915l2.762-.551 2.457 1.378a7.705 7.705 0 0 0 2.436-.942 7.69 7.69 0 0 0 1.239-.928l.33-2.798 2.073-1.915a7.57 7.57 0 0 0-.648-4.072l-2.555-1.177-1.178-2.559a7.552 7.552 0 0 0-3.182-.701ZM8.542 7.33l3.564.564.564 3.563-3.214 1.638-2.552-2.55L8.542 7.33Z",
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavOfferings);
export default __webpack_public_path__ + "static/media/nav-offerings.5101490a26ca9a36c1ebb6d3671133b4.svg";
export { ForwardRef as ReactComponent };